import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    inject,
    input,
    Input,
    Output,
    ViewEncapsulation,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { SafeHtml } from '@angular/platform-browser';
import { CtrlFileDropZoneDirective, CtrlFileSelectDirective, RejectedFile } from '@co-3/ctrl-ui/forms';
import { CtrlIconComponent } from '@co-3/ctrl-ui/icons';
import { CtrlModalsService } from '@co-3/ctrl-ui/modals';
import { PortalActionButtonsComponent } from 'app/customer-portal/components';
import { createMessageFromRejectedFiles } from 'app/customer-portal/fns/create-message-from-rejected-files';
import { DamageReportStepHeaderComponent } from '../../components/damage-report-step-header/damage-report-step-header.component';
import { FileAttachmentMetaModalComponent } from '../../components/file-attachment-meta-modal/file-attachment-meta-modal.component';
import { SelectedFileComponent } from '../../components/selected-file/selected-file.component';
import { CreateDamageReportService } from '../../create-damage-report.service';
import { DamageReportStep, FileWithMeta } from '../../models';

@Component({
    selector: 'app-file-attachment-form-step',
    imports: [
        CtrlFileDropZoneDirective,
        CtrlFileSelectDirective,
        CtrlIconComponent,
        PortalActionButtonsComponent,
        SelectedFileComponent,
        DamageReportStepHeaderComponent,
    ],
    templateUrl: './file-attachment-form-step.component.html',
    styleUrl: './file-attachment-form-step.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
})
export class FileAttachmentFormStepComponent implements DamageReportStep {
    private modalService = inject(CtrlModalsService);
    @Output()
    public onPrev = new EventEmitter<void>();

    @Output()
    public onNext = new EventEmitter<void>();

    @Output()
    public onCancel = new EventEmitter<void>();

    @Input()
    public isFirst = false;

    public introduction = input<string>(
        ' Bitte wähle eine oder mehrere Dateien (z.B. Fotos des Schadens, Rechnungen, Kaufbelege, etc.) aus, die uns helfen können, die Schadensmeldung schnell zu bearbeiten.',
    );

    public addition = input<SafeHtml>();

    public canSkip = input<boolean>(true);

    private createDamageReportService = inject(CreateDamageReportService);

    protected files = toSignal(this.createDamageReportService.filesWithMeta$);

    public handleFilesSelected(files: File[]): void {
        this.openModals(
            files.filter((file) => !this.createDamageReportService.hasFile(file)),
            0,
        );
    }
    protected handleFilesRejected(rejectedFiles: RejectedFile[]): void {
        alert(createMessageFromRejectedFiles(rejectedFiles));
    }

    private openModals(files: File[], currentIndex: number): void {
        this.modalService
            .open(FileAttachmentMetaModalComponent, {
                file: { file: files[currentIndex] } as FileWithMeta,
                currentFileNo: currentIndex + 1,
                totalFileNo: files.length,
            })
            .subscribe((fwm) => {
                if (fwm) {
                    this.createDamageReportService.addFile(fwm);
                }
                if (currentIndex + 1 < files.length) {
                    this.openModals(files, currentIndex + 1);
                }
            });
    }

    public deleteFile(file: FileWithMeta): void {
        this.createDamageReportService.removeFile(file);
    }

    public editFile(file: FileWithMeta): void {
        this.modalService
            .open(FileAttachmentMetaModalComponent, {
                file,
                currentFileNo: 1,
                totalFileNo: 1,
            })
            .subscribe((fwm) => {
                if (fwm) {
                    this.createDamageReportService.updateFile(fwm);
                }
            });
    }
}
